import { Box } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import type { AuthTabBarProps } from "./AuthTabBar.types";
import * as styles from "./AuthTabBar.styles";

export type { AuthTabBarProps } from "./AuthTabBar.types";

export const AuthTabBar = memo(function AuthTabBar({ activeTab }: AuthTabBarProps) {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();

  return (
    <Box sx={styles.root}>
      <Box
        component="button"
        type="button"
        sx={styles.tab(activeTab === "login")}
        onClick={() => navigate({ to: "/login" })}
      >
        {t("login")}
      </Box>
      <Box
        component="button"
        type="button"
        sx={styles.tab(activeTab === "register")}
        onClick={() => navigate({ to: "/register" })}
      >
        {t("register")}
      </Box>
    </Box>
  );
});
